const factory = (TemplateLedger, Collection) => {
  class TemplateLedgerCollection extends Collection {
    $init() {
      super.$init();

      // Automatically fetch the first time this collection is created.
      if (this.$lastUpdated === 0) {
        return this.$fetch();
      }
    }

    findLedgerByCodeAndCountry(code, clientCountry) {
      return this.data.find(templateLedger => {
        const templateLedgerData = templateLedger.$data();
        const clientCountryCodeMatch =
          clientCountry === templateLedgerData.countryCode ||
          templateLedgerData.countryCode === null;

        return code === templateLedgerData.code && clientCountryCodeMatch;
      });
    }
  }

  Object.assign(TemplateLedgerCollection.prototype, {
    $id: 'singleton',
    $resource: 'templateledger',
    $type: TemplateLedger,
    $$cacheModels: true,
  });

  return TemplateLedgerCollection;
};

const moduleDeps = [require('data/model/templateLedger').name, require('data/util').name];

module.exports = angular
  .module('bench.data.collection.templateLedger', moduleDeps)
  .factory('TemplateLedgerCollection', factory);
